import fr from 'facet-rest';
import { BaseOverrideNoHidden } from 'Views/Page/Content/Templates/BaseOverride';

export const PlannerTransitionOverride = fr.metaOverride({ base: BaseOverrideNoHidden })
  .typeOverride('date', {
    _customProps: {
      minDate: new Date(),
      helperText: '',
    },
  }, { ordinal: 200 });
